<table datatable class="table bg-white align-middle effects-table">
    <thead *ngIf="showHeader">
        <tr>
            <th>{{'Determinant' | translate}}</th>
            <th>{{'Action' | translate}}</th>
            <th class="text-center cell-delete">&nbsp;</th>
        </tr>
        <tr><th></th><th></th><th></th></tr>
    </thead>
    <tbody>
        <tr>
            <td><div class="workarea__draghere"><div class="editBtn text-dark">Select</div></div></td>
            <td class="">
                <div class="editBtn text-dark">Choose bot</div>
            </td>
            <td class="cell-delete"><i class="btn-xs btn-bordered btn-danger btn-icon fas fa-times"></i></td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <th colspan="3" class="text-left">
                <div class="d-inline-block btn btn-link btn-sm">
                    <i class="fa fa-plus mr-2"></i>
                    <span>{{'Action triggered by field' | translate}}</span>
                </div>
            </th>
        </tr>
    </tfoot>
</table>